const opcoes = [
  { icon: 'ri-palette-line', titulo: 'Cores', texto: 'Paletas que dialogam com a identidade do ambiente.' },
  { icon: 'ri-bring-to-front', titulo: 'Texturas', texto: 'Acabamentos com diferentes comportamentos táteis.' },
  { icon: 'ri-shapes-line', titulo: 'Padrões', texto: 'Desenhos que definem a personalidade do espaço.' },
  { icon: 'ri-layout-masonry-line', titulo: 'Paginações', texto: 'Composições que orientam circulação e setores.' },
];

export default function AcabamentoSection() {
  return (
    <section className="bg-background-50">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mb-14">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Acabamentos
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[40px] font-semibold tracking-tight leading-tight">
            Opções de acabamento.
          </h2>
          <p className="text-foreground-500 text-[15px] md:text-[16px] leading-relaxed mt-5">
            As linhas e fabricantes disponíveis variam conforme o projeto. Apresentamos opções reais
            e atuais durante a análise, sempre de acordo com a especificação adequada a cada
            ambiente.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {opcoes.map((o) => (
            <div
              key={o.titulo}
              className="bg-white border border-background-200/60 rounded-2xl p-7 hover:border-primary-300 transition-colors"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5">
                <i className={`${o.icon} text-2xl`}></i>
              </span>
              <h3 className="text-foreground-900 text-[16px] font-semibold mb-2">{o.titulo}</h3>
              <p className="text-foreground-500 text-[14px] leading-relaxed">{o.texto}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}